(function () {
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    /* Auto-tag footer content containers */
    var footerContent = document.querySelector('footer .footer-content');
    if (footerContent) footerContent.setAttribute('data-section-reveal', '');

    var footerUtilities = document.querySelector('footer .utilities');
    if (footerUtilities) footerUtilities.setAttribute('data-section-reveal', '');

    var containers = document.querySelectorAll('[data-section-reveal]');

    if (!containers.length) return;

    containers.forEach(function (container) {
      var children = container.children;
      for (var i = 0; i < children.length; i++) {
        children[i].style.setProperty('--reveal-i', i);
      }
    });

    if (prefersReducedMotion) {
      containers.forEach(function (el) {
        el.setAttribute('data-section-reveal', 'visible');
      });
      return;
    }

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                entry.target.setAttribute('data-section-reveal', 'visible');
                observer.unobserve(entry.target);
              }
            });
          },
          {
            threshold: 0.05,
            rootMargin: '0px 0px -40px 0px',
          }
        );

        containers.forEach(function (el) {
          observer.observe(el);
        });
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
